import { Database } from "./Database";
import randomHashGenerator from "../helpers/randomHashGenerator";
class AppNewsSectionDatabase extends Database {
    addDataToSession(key, value) {
        throw new Error("Irrelevant inherited method" + key + value);
    }
    constructor(config, databaseName) {
        super(config, databaseName);
        this.LATEST_APP_VERSION_PATH = "latestAppVersion";
        this.LATEST_MARTY_VERSION_PATH = "latestMartyVersion";
        this.LATEST_NEWS_PATH = "latestNews";
        this.WARNINGS_PATH = "warnings";
        this.QUESTIONS_PATH = "questions";
        this.ANSWERS_PATH = "answers";
        this.WHO_HAVE_ANSWERED_PATH = (questionId) => `${this.QUESTIONS_PATH}/${questionId}/whoHaveAnswered`;
        ///////////////////////////////
        // helpers
        this.dateToPath = (date) => {
            // Mon Jan 22 2024 15:18:21 GMT+0200 (Eastern European Standard Time) => Mon_Jan_22_2024_15_18_21_GMT+0200_(Eastern_European_Standard_Time)
            return date.toString().replace(/-/g, "_").replace(/:/g, "_").replace(/\./g, "_").replace(/\s+/g, "_");
        };
    }
    // VERSIONS
    async getLatestAppVersion() {
        const fetchedObject = await this.get(this.LATEST_APP_VERSION_PATH);
        return (fetchedObject === null || fetchedObject === void 0 ? void 0 : fetchedObject.version) || "";
    }
    async getLatestMartyVersion() {
        const fetchedObject = await this.get(this.LATEST_MARTY_VERSION_PATH);
        return (fetchedObject === null || fetchedObject === void 0 ? void 0 : fetchedObject.version) || "";
    }
    /////////////////////////////////
    // LATEST NEWS
    async getLatestNews(howMany) {
        const fetchedObject = await this.get(this.LATEST_NEWS_PATH);
        const news = fetchedObject || {};
        if (!howMany) {
            return news;
        }
        const newsKeys = Object.keys(news);
        const latestNews = {};
        for (let i = 0; i < howMany; i++) {
            const key = newsKeys[i];
            if (key) {
                latestNews[key] = news[key];
            }
        }
        return latestNews;
    }
    /////////////////////////////////
    // WARNINGS
    async getAllWarnings() {
        const fetchedObject = await this.get(this.WARNINGS_PATH);
        return fetchedObject || {};
    }
    ///////////////////////////////
    // QUESTIONS
    async getAllQuestions() {
        const fetchedObject = await this.get(this.QUESTIONS_PATH);
        return fetchedObject || {};
    }
    async storeQuestion(question) {
        const questionId = randomHashGenerator();
        const path = this.QUESTIONS_PATH + "/" + questionId;
        const questionObj = { question, id: questionId, whoHaveAnswered: {} };
        await this.set(questionObj, path);
        return path;
    }
    async storeAnswerInQuestion(questionId, questionTimestamp, serialNo, deviceId) {
        const path = this.WHO_HAVE_ANSWERED_PATH(questionId) + "/" + questionTimestamp;
        const answerObj = {};
        if (serialNo)
            answerObj.serialNo = serialNo;
        if (deviceId)
            answerObj.deviceId = deviceId;
        await this.set(answerObj, path);
    }
    ///////////////////////////////
    // ANSWERS
    async getAllAnswers() {
        const fetchedObject = await this.get(this.ANSWERS_PATH);
        return fetchedObject || {};
    }
    async getAnswers(questionId) {
        const fetchedObject = await this.get(this.ANSWERS_PATH + "/" + questionId);
        return fetchedObject || {};
    }
    async storeAnswer(questionId, answer, serialNo, deviceId, timestamp) {
        let stringTimestamp;
        if (!timestamp) {
            stringTimestamp = new Date().toString();
        }
        else {
            stringTimestamp = timestamp.toString();
        }
        const path = this.ANSWERS_PATH + "/" + questionId + "/" + stringTimestamp;
        const answerObj = { answer, timestamp: stringTimestamp };
        const wasAnswerStored = await this.set(answerObj, path);
        if (wasAnswerStored) {
            await this.storeAnswerInQuestion(questionId, stringTimestamp, serialNo, deviceId);
        }
    }
}
export default AppNewsSectionDatabase;
